<template>
  <v-card>
    <v-progress-linear v-if="loading" indeterminate height="2"></v-progress-linear>
    <template v-if="user">
      <user-header :user="user"></user-header>
      <template v-if="$can('view', 'customers')">
        <v-tabs grow centered dark scroll-bars>
          <v-divider></v-divider>
          <v-tabs-bar class="grey lighten-5" slot="activators">
            <v-tabs-item
              v-for="tab in tabs" :key="tab.key"
              router
              :href="{ name: 'User', params: { id: user.id, tab: tab.key } }"
              ripple>
              {{ $t(`pages.user.tabs.${tab.key}`) }}
            </v-tabs-item>
          </v-tabs-bar>
        </v-tabs>
        <v-divider></v-divider>
        <component :is="currentTab.component" :user="user"></component>
      </template>
    </template>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import {
    UserHeader,
    UserProfile,
    UserStatistics,
    UserPurchases
  } from '@/components/user'
  export default {
    components: {
      UserHeader
    },
    props: {
      id: {
        type: Number,
        required: true
      },
      tab: {
        type: String,
        default: () => this.tabs[0].key
      }
    },
    computed: {
      ...mapGetters({
        users: 'skiliko/users/collection',
        loading: 'skiliko/users/isLoading'
      }),
      user () {
        return this.users[this.id]
      },
      tabs () {
        return [
          { key: 'profile', component: UserProfile },
          { key: 'statistics', component: UserStatistics },
          { key: 'purchases', component: UserPurchases }
        ]
      },
      currentTab () {
        return this.tabs.filter(tab => tab.key === this.tab)[0]
      }
    },
    methods: mapActions({
      fetch: 'skiliko/users/fetch'
    }),
    mounted () {
      this.fetch({ id: this.id })
    }
  }
</script>

<style scoped>
  .progress-linear { margin: 0; }
</style>



// WEBPACK FOOTER //
// src/pages/User.vue